import React, { FC, useEffect, useState } from "react";
import EnhancementProcedureForCghs from "../../components/patient/Enhancement/EnhancementProcedureForCghs";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { fetchProcedure } from "../../models/preAuthClaimSlice";
import {
  deleteUploadedDocument,
  downloadDocument,
  enhancementService,
  fetchEnhancementProcedure,
  getAllStarhealthDocumentsData,
  getProcedureAmount,
  getStratsData,
} from "../../apis/patientService";
import { errorMessage, successMessage } from "../../utils/notificationUtils";
import { Button, message } from "antd";
import EnhancementCghsDocument from "../../components/patient/Enhancement/EnhancementCghsDocument";
import { UploadDocument } from "../../models/EnhancementSlice";
import FilePreviewModal from "../../components/patient/PreAuth-query/FilePreviewModal";
import { IDocumentFields } from "../../interfaces/ICase";
import { getDeficiencyQuestionData } from "../../models/patientSlice";
import RightSidePreviewModal from "../../components/modals/RightSidePreviewModal";
import DocumentDeficiencyModal from "../../components/patient/DocumentDeficiencyModal";
import { Form } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import EnhancementProcedureForCghsModal from "../../components/patient/Enhancement/EnhancementProcedureForCghsModal";
import dayjs from "dayjs";
import { fetchEnhancementDataService } from "../../apis/EnhancementService";
import EnhancementProcedureListForCghs from "../../components/patient/Enhancement/EnhancementProcedureListForCghs";
import Loader from "../../utils/Spinners";
interface EnhancementProcedureForCghsContainerProps {
  onfetchStepper: () => void; // Define prop type for the function
}
const EnhancementProcedureForCghsContainer: FC<
  EnhancementProcedureForCghsContainerProps
> = (props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const { patients, hospital, preAuthClaim, preAuth, enhancement, auth } =
    useSelector((state: RootState) => state);
  const [enhancementProcedure, setEnhancementProcedure] = useState<any>([]);
  const [procedureStrats, setProcedureStrats] = useState({}); //to store strats of procedure
  const [addNewEnhancementModal, setAddNewEnhancementModal] =
    useState<boolean>(false);
  const [deleteProcedureList, setDeleteProcedureList] = useState<any[]>([]);
  const [activeKey, setActiveKey] = useState<string>("1");
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false); //to open modal for confirmation of deletion of the procedure
  const [documentTypes, setDocumentTypes] = useState([]);
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });
  const [uploadedDocumentUrl, setUploadedDocumentUrl] = useState<
    Array<IDocumentFields>
  >([]);
  const [selectedFile, setSelectedFile] = useState<{
    file: File;
    documentType: string;
  } | null>(null);
  const [enhancementsList, setEnhancementsList] = useState([]);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [documentUrl, setDocumentUrl] = useState<string>("");
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [documentName, setDocumentName] = useState("");
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [caseEnhancementId, setCaseEnhancementId] = useState<string | null>(
    null
  );
  const [isFetchingEnhancementData, setIsFetchingEnhancementData] =
    useState<boolean>(false);
  const [isFetchingProcedures, setIsFetchingProcedures] =
    useState<boolean>(false);
  const [isDownloadingDocument, setIsDownloadingDocument] =
    useState<boolean>(false);
  const [downloadingDocumentUrl, setDownloadingDocumentUrl] =
    useState<string>("");
  const fetchDocuments = async (
    schemeMetaDataId: number,
    caseId: number,
    visitId: number
  ) => {
    try {
      // const documentList = await getDocuments(props?.schemeMetaDataId);
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id
      ) {
        const AllDocumentList = await getAllStarhealthDocumentsData(
          caseId,
          visitId,
          schemeMetaDataId
        );
        setDocumentTypes(AllDocumentList?.["Enhancement"]);
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
    }
  };
  useEffect(() => {
    fetchEnhancementData();
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
  ]);
  useEffect(() => {
    if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
      if (
        patients?.fetchBasicDetails?.casesResponse?.patientSchemeId &&
        patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName && patients?.fetchBasicDetails?.casesResponse?.healthCareId
      ) {
        dispatch(
          fetchProcedure({
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
            isCghs:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
              "CGHS"
                ? true
                : false,
            procedureType:
              patients?.fetchBasicDetails?.visitInfoResponse?.visitType === "OP"
                ? "OP"
                : "IP",
            schemeId:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          })
        );
      }
      fetchDocuments(
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        patients?.fetchBasicDetails?.casesResponse?.id,
        patients?.fetchBasicDetails?.visitInfoResponse?.id
      );
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.healthCareId,
    patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.casesResponse?.patientSchemeId,
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
    patients?.fetchBasicDetails?.visitInfoResponse?.visitType,
  ]);
  const formattedAccreditationOptions: Array<{ label: string; value: string }> =
    [
      { label: "NABL", value: "NABL" },
      { label: "NON NABL", value: "NON NABL" },
    ]?.map((option) => ({
      value: option?.value + "~" + option?.label,
      label: option.label,
    }));
  const formattedTreatingDoctorsOptions: Array<{
    label: string;
    value: string;
  }> = [{ treatingDoctorCode: "OTHERS", treatingDoctorName: "OTHERS" }]?.map(
    (option) => ({
      value: option?.treatingDoctorCode + "~" + option?.treatingDoctorName,
      label: option?.treatingDoctorName,
    })
  );
  const formattedProcedureReferral: Array<{ label: string; value: string }> = [
    { label: "REFERRAL", value: "referral" },
    { label: "NON REFERRAL", value: "non referral" },
  ]?.map((option) => ({
    value: option?.value + "~" + option?.label,
    label: option.label,
  }));
  const formattedProceduresOptions: Array<{ label: string; value: string }> =
    preAuthClaim?.procedureDropDown
      ? preAuthClaim?.procedureDropDown?.map((option: any) => ({
          value: JSON.stringify(option),
          label: option?.procedureName,
        }))
      : [];
  const onChangeKey = (key: string) => {
    setActiveKey(key);
  };
  const handleGetProcedureAmount = async (formData: any) => {
    try {
      const newFormData = {
        ...formData,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        isCghs:
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CGHS"
            ? true
            : false,
      };
      const procedureAmountRes = await getProcedureAmount(newFormData);
      return procedureAmountRes;
    } catch (err: any) {
      // errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };
  const handleGetProcedureStrats = async (formData: any) => {
    try {
      const newFormData = {
        ...formData,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        isCghs:
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CGHS"
            ? true
            : false,
      };
      const procedureStrats = await getStratsData(newFormData);
      setProcedureStrats((prevStrats) => ({
        ...prevStrats,
        [formData.procedureId]: procedureStrats,
      }));
      return procedureStrats;
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };
  const fetchEnhancementData = async () => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        setIsFetchingEnhancementData(true);
        const newData: any = await fetchEnhancementDataService(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id
        );
        setEnhancementsList(newData);
        setIsFetchingEnhancementData(false);
      }
      // Fetch portal meta data
    } catch (error: any) {
      errorMessage(error.message || "Please, Try again later");
      setIsFetchingEnhancementData(false);
    }
  };
  const handleFetchProcedureList = async () => {
    try {
      setIsFetchingProcedures(true);
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const res = await fetchEnhancementProcedure(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
        );
        setEnhancementProcedure(res);
        setIsFetchingProcedures(false);
      }
    } catch (err: any) {
      setIsFetchingProcedures(false);
      errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };
  const handleDeleteProcedure = async (procedure: any) => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const portalMetaData = await enhancementService.getPortalMetaData(
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
        );
        // const formData = {
        //   caseTherapyId,
        //   proccode: procedureCode,
        // };
        setDeleteProcedureList((prevList) => [...prevList, procedure]);
        // await deleteEnhancementProcedure(portalMetaData.portalMetaDataIdsList[0], formData);
        successMessage("Procedure added in archieve list");
        return true;
      }
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
      return false;
    }
  };
  const handleSubmitEnhancementProcedure = async (values: any) => {
    try {
      // const alreadyAddedProcedures = enhancementProcedure?.filter((procedure: any) => {
      //   if (!deleteProcedureList || deleteProcedureList.length === 0) {
      //     return true;
      //   }

      //   return !deleteProcedureList?.some((deletedProcedure: any) => deletedProcedure.id === procedure.id);
      // });
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const portalMetaData = await enhancementService.getPortalMetaData(
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
        );
        const formData = {
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          claimId: preAuth?.portalData?.casePreAuthCghs?.claimId,
          registrationId: preAuth?.portalData?.schemeRegistrationId,
          regnId: preAuth?.portalData?.schemeRegistrationId,
          documentUrls: uploadedDocumentUrl || [],
          // enhancementProceduresRequestList:
          //   alreadyAddedProcedures?.length > 0 && values?.length > 0
          //     ? [...alreadyAddedProcedures, ...values]
          //     : values?.length > 0 ? values : alreadyAddedProcedures?.length > 0 ? alreadyAddedProcedures : [],
          enhancementProceduresRequestList: values?.length > 0 ? values : [],
          deleteProcList: deleteProcedureList,
          status: true,
          dateOfAdmission: patients?.fetchBasicDetails?.visitInfoResponse?.doa,
          dod: patients?.fetchBasicDetails?.visitInfoResponse?.dod,
        };
        // const res = await upsertEnhancementProcedure(
        //   portalMetaData.portalMetaDataIdsList[0],
        //   formData
        // );
        await enhancementService.saveEnhancementData(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          portalMetaData.portalMetaDataIdsList[0],
          caseEnhancementId,
          formData
        );
        setAddNewEnhancementModal(false);
        setUploadedDocumentUrl([]);
        setEnhancementProcedure([]);
        setDeleteProcedureList([]);
        setActiveKey("1");
        form.resetFields();
        fetchEnhancementData();
        props?.onfetchStepper();
      }
    } catch (err: any) {
      errorMessage(err?.response?.data || "Please, Try again after sometime");
    }
  };
  const handleOk = (procedure: any) => {
    handleDeleteProcedure(procedure);
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleFileChange = (documentType: string) => (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    if (e?.file) {
      setSelectedFile({ file: e.file, documentType: documentType });
      setPreviewFile({
        url: URL.createObjectURL(e.file),
        name: e.file.name,
        showUpload: true,
        documentType: documentType,
      });
      setPreviewModalVisible(true);
    }
    return e?.target?.files;
  };
  const handleUpload = async () => {
    const CollectPostData = new FormData();
    if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      CollectPostData.append(
        "hospitalId",
        patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.patientResponse?.id) {
      CollectPostData.append(
        "patientId",
        patients?.fetchBasicDetails?.patientResponse?.id?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      CollectPostData.append(
        "caseId",
        patients?.fetchBasicDetails?.casesResponse?.id?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      CollectPostData.append(
        "visitId",
        patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
      );
    }
    CollectPostData.append("documentType", previewFile.documentType);
    if (selectedFile?.file) {
      CollectPostData.append("file", selectedFile?.file);
    }
    try {
      const documentRes = await dispatch(
        UploadDocument({
          formData: CollectPostData,
          accessToken: auth.accessToken || "",
        })
      ).unwrap();
      // const updatedDocuments = updateOrAddDocument(
      //   uploadedDocumentUrl,
      //   documentRes
      // );
      const updatedDocuments = [...uploadedDocumentUrl, ...documentRes]; 
      setUploadedDocumentUrl(updatedDocuments);
      setPreviewModalVisible(false);
      message.success(
        `${documentRes?.[0]?.documentLabelType} uploaded successfully`
      );
    } catch (error) {
      console.error("Failed to upload document:", error);
    }
  };
  const updateOrAddDocument = (
    uploadedDocumentUrl: Array<IDocumentFields>,
    documentRes: IDocumentFields
  ): Array<IDocumentFields> => {
    const updatedDocuments = [...uploadedDocumentUrl];
    updatedDocuments.push({
      documentType: documentRes?.documentType,
      documentName: documentRes?.documentName,
      documentUrl: documentRes?.documentUrl,
      documentLabelType: documentRes?.documentLabelType,
      id: documentRes?.id,
      deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
    });
    // Return the updated array (ensures it's a flat array)
    return updatedDocuments;
  };
  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      setDownloadingDocumentUrl(url);
      setIsDownloadingDocument(true);
      await downloadDocument(fileName, url);
      successMessage("Document Downloaded Successfully");
      setDownloadingDocumentUrl("");
      setIsDownloadingDocument(false);
    } catch (err: any) {
      errorMessage("Please, Try again later");
      setDownloadingDocumentUrl("");
      setIsDownloadingDocument(false);
    }
  };
  const handleOpen = () => {
    setPreviewDocument(true);
  };
  const handleSetDocumentUrl = (url: string) => {
    setDocumentUrl(url);
  };
  const handleDeleteList = async (
    documentType: string,
    documentUrl: string,
    i: number
  ) => {
    const deleteDocument = uploadedDocumentUrl?.find(
      (doc, index) => doc?.documentUrl === documentUrl
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };
    const newUpdatedDocumentList = uploadedDocumentUrl?.filter(
      (doc, index) => doc?.documentUrl !== documentUrl
    );
    setUploadedDocumentUrl(newUpdatedDocumentList);
    if (deleteDocument?.documentUrl) {
      try {
        await deleteUploadedDocument(deleteForm);
        message.success("Document Deleted Successfully");
      } catch (err) {
        console.error(err);
      }
    }
  };
  const fetchDeficiencyData = async (
    selectedDocument: any,
    selectedDocumentId: any
  ) => {
    try {
      if (selectedDocument?.id) {
        const secondRes = await dispatch(
          getDeficiencyQuestionData(selectedDocument?.id)
        );
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setSelectedDocument(null);
    }
  };
  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: IDocumentFields
  ) => {
    await fetchDeficiencyData(document, documentId);
    setPreviewDocumentUrl(documentUrl);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };
  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocument(null);
  };
  const handleCancelPreview = () => {
    setPreviewDocument(false);
  };
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const updatedValues = values?.items?.map((value: any) => {
        let result: any = {
          ...value,
          procedureReferral: value?.procedureReferral?.split("~")?.[0],
          procedureReferralName: value?.procedureReferral?.split("~")?.[1],
          accreditationStatus: value?.accreditationStatus?.split("~")?.[0],
          accreditationStatusName: value?.accreditationStatus?.split("~")?.[1],
          treatingDoctorCode: value?.treatingDoctor?.split("~")?.[0],
          treatingDoctor: value?.treatingDoctor?.split("~")?.[1],
          treatmentStartDate: value?.treatmentStartDate
            ? dayjs(value?.treatmentStartDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          ...JSON.parse(value?.procedureCode),
          stratsId: JSON.parse(value?.procedureCode)?.id,
          status: true,
        };
        if (value?.stratOptionValue) {
          result = { ...result, ...JSON.parse(value.stratOptionValue) };
        }
        delete result?.["id"];
        return result;
      });
      await handleSubmitEnhancementProcedure(updatedValues);
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please fill all details before submitting");
      }
    }
  };
  const handleNext = async () => {
    setActiveKey((parseInt(activeKey) + 1)?.toString());
  };
  const handlePrevious = () => {
    setActiveKey((parseInt(activeKey) - 1)?.toString());
  };
  const handleCancelEnhancementModal = () => {
    setAddNewEnhancementModal(false);
  };
  const items = [
    {
      key: "1",
      label: "Procedure",
      children: (
        <EnhancementProcedureForCghs
          onfetchStepper={props?.onfetchStepper}
          handleFetchProcedureList={handleFetchProcedureList}
          enhancementProcedure={enhancementProcedure}
          formattedAccreditationOptions={formattedAccreditationOptions}
          formattedTreatingDoctorsOptions={formattedTreatingDoctorsOptions}
          formattedProcedureReferral={formattedProcedureReferral}
          formattedProceduresOptions={formattedProceduresOptions}
          handleGetProcedureAmount={handleGetProcedureAmount}
          handleGetProcedureStrats={handleGetProcedureStrats}
          patientDetails={patients?.fetchBasicDetails}
          procedureStrats={procedureStrats}
          handleDeleteProcedure={handleDeleteProcedure}
          handleSubmitEnhancementProcedure={handleSubmitEnhancementProcedure}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          form={form}
          onNext={handleNext}
          onPrevious={handlePrevious}
          activeStep={activeKey}
        />
      ),
    },
    {
      key: "2",
      label: "Document",
      children: (
        <div>
          <EnhancementCghsDocument
            documentTypes={documentTypes}
            handleFileChange={handleFileChange}
            uploadedDocumentUrl={uploadedDocumentUrl}
            handleDownloadDocument={handleDownloadDocument}
            isDownloadingDocument={isDownloadingDocument}
            downloadingDocumentUrl={downloadingDocumentUrl}
            handleOpen={handleOpen}
            handleSetDocumentUrl={handleSetDocumentUrl}
            handleDeleteList={handleDeleteList}
            setDocumentName={setDocumentName}
            handleDeficiencyModal={handleDeficiencyModalOpen}
            deficiencyQuestions={patients?.deficiencyCheckQuestions}
            form={form}
            handleSubmit={handleSubmit}
            onPrevious={handlePrevious}
            activeStep={activeKey}
          />
          <FilePreviewModal
            isVisible={previewModalVisible}
            onClose={() => setPreviewModalVisible(false)}
            fileUrl={previewFile.url}
            fileName={previewFile.name}
            documentType={previewFile.documentType}
            handleUpload={handleUpload}
            showUploadButton={previewFile.showUpload}
            key={selectedFile?.file?.lastModified || "no-file"}
            isLoading={enhancement?.isLoading}
          />
          <RightSidePreviewModal
            key={documentUrl}
            documentUrl={documentUrl}
            handleCancel={handleCancelPreview}
            open={previewDocument}
          />
          <DocumentDeficiencyModal
            key={previewDocumentUrl}
            closeDeficiencyModal={closeDeficiencyModal}
            deficiencyModal={deficiencyModal}
            documentUrl={previewDocumentUrl}
            documentName={documentName}
            handleDownloadDocument={handleDownloadDocument}
            isDownloadingDocument={isDownloadingDocument}
            downloadingDocumentUrl={downloadingDocumentUrl}
            deficiencyQuestions={patients?.deficiencyCheckQuestions}
            selectedDocument={selectedDocument}
            setUploadedDocumentUrl={setUploadedDocumentUrl}
          />
        </div>
      ),
    },
  ];

  const currentStageId = preAuth?.stepperData?.currentVisitStage?.visitStageId;
  const currentStep = preAuth?.currentStep;
  const visitStages = preAuth?.stepperData?.visitStages;
  const stepStageId = visitStages?.[currentStep]?.visitStageId;

  return (
    <div style={{ padding: "14px" }} className="Deepak">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <h4 style={{ fontSize: "18px", fontWeight: "700" }}>Enhancement</h4>
        {!(currentStageId && stepStageId && currentStageId > stepStageId) ? (
          <Button
            icon={<PlusOutlined />}
            onClick={() => {
              setAddNewEnhancementModal(true);
              handleFetchProcedureList();
            }}
          >
            Add New Enhancement
          </Button>
        ) : (
          <></>
        )}
      </div>
      <EnhancementProcedureForCghsModal
        addNewEnhancementModal={addNewEnhancementModal}
        items={items}
        activeKey={activeKey}
        onChangeKey={onChangeKey}
        handleCancel={handleCancelEnhancementModal}
        handleSubmit={handleSubmit}
        isFetchingPortalData={isFetchingProcedures}
      />
      {isFetchingEnhancementData ? (
        <Loader />
      ) : (
        <EnhancementProcedureListForCghs
          enhancementsList={enhancementsList}
          handleDownloadDocument={handleDownloadDocument}
          isDownloadingDocument={isDownloadingDocument}
          downloadingDocumentUrl={downloadingDocumentUrl}
          handleOpen={handleOpen}
          handleSetDocumentUrl={handleSetDocumentUrl}
          setDocumentName={setDocumentName}
          handleDeficiencyModal={handleDeficiencyModalOpen}
        />
      )}
      <RightSidePreviewModal
        key={documentUrl}
        documentUrl={documentUrl}
        handleCancel={handleCancelPreview}
        open={previewDocument}
      />
    </div>
  );
};
export default EnhancementProcedureForCghsContainer;
